import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'croreFormatter'
})
export class CroreFormatterPipe implements PipeTransform {
  transform(value: number): string {
    if (value || value === 0) {
      const croreValue = value / 10000000;
      return croreValue.toFixed(4) + ' Cr';
    } else {
      return '';
    }
  }
}
